import {
  DatePicker as AntdDatepicker,
  DatePickerProps as AntdDatePickerProps,
  TimePicker as AntdTimepicker,
  TimePickerProps as AntdTimepickerProps,
} from "antd";
import { CMP_PREFIX } from "@/base/constant";
import dayjsGenerateConfig from "rc-picker/lib/generate/dayjs";
import {
  CalendarIcon,
  ArrowRightLineIcon,
  RemoveIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  TimeIcon,
  DoubleChevronRightIcon,
  DoubleChevronLeftIcon,
} from "@/base/static/index";
import type { Dayjs } from "dayjs";

const MomentDatePicker: any =
  AntdDatepicker.generatePicker<Dayjs>(dayjsGenerateConfig);

export interface DatepickerProps extends AntdDatePickerProps<Dayjs> {}
export interface TimepickerProps extends AntdTimepickerProps {}

export const datepickerPrefixCls = `${CMP_PREFIX}-picker`;

export const Datepicker = ({
  format = "DD.MM.YYYY",
  size = "large",
  ...props
}: DatepickerProps) => {
  return (
    <MomentDatePicker
      size={size}
      format={format}
      nextIcon={<ChevronRightIcon size={20} />}
      prevIcon={<ChevronLeftIcon size={20} />}
      superNextIcon={<DoubleChevronRightIcon size={20} />}
      superPrevIcon={<DoubleChevronLeftIcon size={20} />}
      suffixIcon={<CalendarIcon size={20} />}
      separator={<ArrowRightLineIcon size={20} />}
      allowClear={{
        clearIcon: <RemoveIcon size={20} />,
      }}
      {...props}
    />
  );
};

export const DatepickerRange = ({
  format = "DD.MM.YYYY",
  size = "large",
  ...props
}: DatepickerProps) => {
  return (
    <MomentDatePicker.RangePicker
      size={size}
      format={format}
      nextIcon={<ChevronRightIcon size={20} />}
      prevIcon={<ChevronLeftIcon size={20} />}
      superNextIcon={<DoubleChevronRightIcon size={20} />}
      superPrevIcon={<DoubleChevronLeftIcon size={20} />}
      suffixIcon={<CalendarIcon size={20} />}
      separator={<ArrowRightLineIcon size={20} />}
      allowClear={{
        clearIcon: <RemoveIcon size={20} />,
      }}
      {...props}
    />
  );
};

export const Timepicker = ({ size = "large", ...props }: TimepickerProps) => {
  return (
    <AntdTimepicker
      size={size}
      suffixIcon={<TimeIcon size={20} />}
      allowClear={{
        clearIcon: <RemoveIcon size={20} />,
      }}
      {...props}
    />
  );
};
